module.exports = __webpack_public_path__ + "static/media/MT.f62e913b.jpg";